import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IUserPaymentsState} from "../reducers/payments.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getPaymentsState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.userPayments);

export const getPayments = createSelector(getPaymentsState,
  (state: IUserPaymentsState) => state && state.userPaymentsData && state.userPaymentsData.userPaymentsData ? state.userPaymentsData.userPaymentsData : null
);

export const getPaymentsLoading = createSelector(getPaymentsState,
  (state: IUserPaymentsState) =>
    state.userPaymentsData.loading
);

export const getPaymentsLoaded = createSelector(getPaymentsState,
  (state: IUserPaymentsState) =>
    state.userPaymentsData.loaded
);
